module.exports = __webpack_public_path__ + "static/media/marcasElectricidad.bae721a6.jpg";